var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillCheckBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-check 1",
    filter: "url(#filter0_d_0_14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M7.4336 11.4553C6.91799 11.9709 6.08201 11.9709 5.5664 11.4553L1.54473 7.4336C1.02911 6.91799 1.02911 6.08201 1.54473 5.5664L5.5664 1.54473C6.08201 1.02911 6.91799 1.02911 7.4336 1.54473L11.4553 5.5664C11.9709 6.08201 11.9709 6.91799 11.4553 7.4336L7.4336 11.4553Z",
    fill: "url(#paint0_linear_0_14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    d: "M10.7371 6.71545C10.8561 6.59646 10.8561 6.40354 10.7371 6.28455L6.71545 2.26288C6.59646 2.1439 6.40354 2.1439 6.28455 2.26288L2.26288 6.28455C2.1439 6.40354 2.1439 6.59646 2.26288 6.71545L6.28455 10.7371C6.40354 10.8561 6.59646 10.8561 6.71545 10.7371L10.7371 6.71545ZM7.4336 11.4553C6.91799 11.9709 6.08201 11.9709 5.5664 11.4553L1.54473 7.4336C1.02911 6.91799 1.02911 6.08201 1.54473 5.5664L5.5664 1.54473C6.08201 1.02911 6.91799 1.02911 7.4336 1.54473L11.4553 5.5664C11.9709 6.08201 11.9709 6.91799 11.4553 7.4336L7.4336 11.4553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    d: "M6.45279 8.28091L10.2752 4.45847L9.55715 3.74039L6.09375 7.2038L5.03091 6.14096C4.8326 5.94265 4.51115 5.94265 4.31284 6.14096C4.11452 6.33927 4.11452 6.66073 4.31284 6.85904L5.73471 8.28091C5.93302 8.47923 6.25448 8.47923 6.45279 8.28091Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_14",
    x: -1,
    y: -1,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_14",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_14",
    x1: 4.49306,
    y1: 3.0381,
    x2: 10.005,
    y2: 8.54798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#863AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5936E4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillCheckBadge);
export default __webpack_public_path__ + "static/media/skill-check-badge.a4b317c2d41b9db265aaddd362789e7d.svg";
export { ForwardRef as ReactComponent };